/* projects/shared/nvps-libraries/design/nv-logo/nv-logo.component.scss */
:host,
nv-logo {
  height: var(--space-5xl);
}
:host svg,
nv-logo svg {
  height: inherit;
  width: inherit;
}
:host:focus-visible,
nv-logo:focus-visible {
  outline: 1px solid var(--color-white);
  outline-offset: 1px;
  border-radius: 1px;
}
/*# sourceMappingURL=nv-logo.component-FLZZO2DW.css.map */
